module.exports = __webpack_public_path__ + "img/pr-6.83b756be.png";